<template>
  <div class="centerBox">
    <div class="BoxHead">
      <TabCheck
        :defaultActive="defaultActive"
        :tabs="tabs"
        @tab-change="handleTabChange"
        @refresh-change="handleRefreshChange"
      />
    </div>
    <div v-if="loading" class="skeleton-container">
      <div class="skeleton-item" v-for="i in 3" :key="i">
        <div class="skeleton-head">
          <div class="skeleton-avatar"></div>
          <div class="skeleton-info">
            <div class="skeleton-line line-1"></div>
            <div class="skeleton-line line-2"></div>
          </div>
        </div>
        <div class="skeleton-title"></div>
        <div class="skeleton-image"></div>
        <div class="skeleton-desc"></div>
        <div class="skeleton-actions">
          <div class="skeleton-btn"></div>
          <div class="skeleton-btn"></div>
          <div class="skeleton-btn"></div>
        </div>
      </div>
    </div>
    <div class="loadBox" v-if="isRefresh">
      <div class="spinner"></div>
    </div>
    <div :class="{ refreshBox: isRefresh }" style="transition-duration: 300ms">
      <FmContent
        v-if="total > 0 && !loading"
        :arrList="arrList"
        :isLoading="isLoading"
        :isFind="true"
        :isType="1"
        :noMoreData="noMoreData"
        @load-more="handleLoadMore"
      />
    </div>
    <div class="noneData" v-if="total === 0 && !loading">
      <img
        class="noneIcon"
        :src="
          $utils.getPng(
            $store.state.theme == 'light'
              ? 'icon-gfans-none'
              : 'icon-gfans-none-dark'
          )
        "
      />
      <div class="font1">暂未订阅订阅号</div>
      <div class="font2">查看发现寻找兴趣吧</div>
    </div>
  </div>
</template>

<script>
import { getHomeList } from '@/axios/home'
import FmContent from '@/components/FmContent/index'
import { eventBus } from '@/utils/event-bus'
import TabCheck from '@/components/TabCheck/index'
import { scrollPosCache } from '@/utils/scrollCache'
export default {
  name: 'home',
  components: {
    FmContent,
    TabCheck,
  },
  data() {
    return {
      arrList: [],
      loading: true,
      isLoading: false,
      noMoreData: false,
      page: 1,
      limit: 30,
      total: null,
      tabs: [
        { id: 0, name: '我的订阅' },
        { id: 1, name: '发现' },
      ],
      defaultActive: 1,
      isRefresh: false,
    }
  },
  beforeRouteLeave(to, from, next) {
    this.defaultActive = 1
    scrollPosCache[from.path] = window.pageYOffset
    next()
  },
  activated() {
    //组件激活
    const savedPos = scrollPosCache[this.$route.path]
    let num = savedPos !== undefined ? savedPos : 0
    this.$nextTick(() => {
      window.scrollTo(0, num)
    })
  },
  mounted() {
    // 监听更新发现数据事件
    eventBus.$on('upHomeList', () => {
      this.scrollToTop()
      this.loading = true
      this.isLoading = false
      this.noMoreData = false
      this.arrList = []
      this.page = 1
      this.fetchData()
    })
    eventBus.$on('itemUpdated', this.updateListItem)
  },
  beforeDestroy() {
    eventBus.$off('upHomeList')
    eventBus.$off('itemUpdated', this.updateListItem)
  },
  created() {
    this.fetchData()
  },
  methods: {
    //初始化数据
    async fetchData() {
      if (this.isLoading || this.noMoreData) return

      this.isLoading = true
      try {
        let data = {
          page: this.page,
          limit: this.limit,
        }
        let res = await getHomeList(data)
        if (res.status == 1) {
          // 处理vhtml字段
          const processedList = res.data.list.map(item => {
            // 复制原始数据
            const newItem = { ...item }
            // 处理vhtml
            if (item.vhtml) {
              newItem.vhtml = item.vhtml
                .replace(/<(?!\/?(img|font|p|div)|[! ])[^>]*>/g, '')
                .replace(
                  /<font([^>]*)\ssize\s*=\s*["'][^"']*["']([^>]*)>/gi,
                  '<font$1$2>'
                )
            }
            //如果是走的刷新
            if (this.isRefresh) {
              newItem.visible = true
              newItem.imageLoaded = false // 重置为未加载
              newItem.imageError = false // 重置为未出错
              newItem.blurStyle = 'blur(15px)' // 恢复初始模糊
            }
            return newItem
          })
          this.arrList =
            this.page == 1
              ? [...processedList] // 首页直接赋值
              : [...this.arrList, ...processedList] // 后续页追加数据
          this.total = Number(res.data.total)
          this.noMoreData = this.arrList.length >= this.total
          this.page++
        }
        this.loading = false
      } catch {
        this.noMoreData = true
      } finally {
        this.isRefresh = false
        this.isLoading = false
      }
    },
    //加载更多
    handleLoadMore() {
      this.fetchData()
    },
    updateListItem(updatedData) {
      // 解构出匹配条件和需要更新的字段
      const { fshort, userid, ...fields } = updatedData
      // 定义匹配函数（根据传入的条件决定使用fshort还是userid）
      const matchFn = item => {
        if (fshort !== undefined) {
          return item.fshort == fshort
        } else if (userid !== undefined) {
          return item.userid == userid
        }
        return false // 必须提供至少一个匹配条件
      }

      // 找到所有匹配的元素（支持多个结果）
      const matchedItems = this.arrList
        .map((item, index) => ({ item, index }))
        .filter(({ item }) => matchFn(item))

      // 批量更新所有匹配的元素
      matchedItems.forEach(({ item, index }) => {
        const updatedItem = { ...item, ...fields }
        this.$set(this.arrList, index, updatedItem)
      })

      // 返回更新的数量（可选，用于调试）
      return matchedItems.length
    },
    //刷新按钮
    handleRefreshChange: _.debounce(
      function () {
        if (this.isRefresh) {
          return
        }
        this.isRefresh = true
        this.isLoading = false
        this.noMoreData = false
        this.page = 1
        // this.arrList = []
        this.fetchData()
        this.scrollToTop()
      },
      500,
      {
        leading: true, //指定在延迟开始前调用
        trailing: false, //指定在延迟结束后调用
      }
    ),
    //切换tab
    handleTabChange: _.debounce(
      function (row) {
        if (this.defaultActive == row) {
          if (window.scrollY == 0) {
            // 如果正在刷新中，直接返回，不执行任何逻辑
            if (this.isRefresh) {
              return
            }
            this.isRefresh = true
            this.isLoading = false
            this.noMoreData = false
            this.page = 1
            // this.arrList = []
            this.fetchData()
          } else {
            window.scrollTo({
              top: 0,
              behavior: 'smooth', // 平滑滚动
            })
          }
          return
        }
        if (this.$store.state.isLogin == 0) {
          eventBus.$emit('showLogin', {})
          return
        }
        this.defaultActive = row
        if (row == 0) {
          this.$router.push({ path: '/subscribe' })
        } else {
          this.$router.push({ path: '/discover' })
        }
      },
      500,
      {
        leading: true, //指定在延迟开始前调用
        trailing: false, //指定在延迟结束后调用
      }
    ),
    // 回到顶部
    scrollToTop() {
      window.scrollTo(0, 0)
    },
  },
}
</script>

<style lang="scss" scoped>
.centerBox {
  margin-top: -72px;
  position: relative;
  .BoxHead {
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: sticky;
    top: 0;
    z-index: 400;
    height: 72px;
    min-height: 72px;
    max-width: 600px;
    width: 100%;
  }
  @media (max-width: 1100px) {
    .BoxHead {
      width: calc(100% - 600px);
      min-width: 450px;
      max-width: 100%;
    }
  }
  /* 当屏幕宽度小于等于700px时 */
  @media (max-width: 700px) {
    .BoxHead {
      width: calc(100% - 600px);
      min-width: 350px;
      max-width: 100%;
    }
  }
  /* 当屏幕宽度小于等于600px时 */
  @media (max-width: 600px) {
    .BoxHead {
      width: calc(100% - 600px);
      min-width: 300px;
      max-width: 100%;
    }
  }
  /* 当屏幕宽度小于等于550px时 */
  @media (max-width: 550px) {
    .BoxHead {
      width: calc(100% - 600px);
      min-width: 160px;
      max-width: 100%;
    }
  }
  /* 骨架屏样式 */
  .skeleton-container {
    height: 100%;
    border-radius: 16px 16px 0px 0px;
    @include useTheme {
      background: getVar('bg-color-content');
    }
  }

  .skeleton-item {
    border-radius: 16px;
    margin-bottom: 16px;
    padding: 16px;
    @include useTheme {
      background: getVar('bg-color-content');
    }
    &:nth-child(even) {
      animation: pulse 1.5s infinite ease-in-out;
    }

    &:nth-child(odd) {
      animation: pulse 1.5s 0.3s infinite ease-in-out;
    }
    &:last-child {
      margin-bottom: 0;
    }
  }

  .skeleton-head {
    display: flex;
    align-items: center;
    margin-bottom: 16px;
  }

  .skeleton-avatar {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    @include useTheme {
      background: getVar('bg-color1-f4f6f8');
    }
  }

  .skeleton-info {
    margin-left: 12px;
    flex: 1;
  }

  .skeleton-line {
    height: 16px;
    border-radius: 8px;
    margin-bottom: 6px;
    @include useTheme {
      background: getVar('bg-color1-f4f6f8');
    }
  }

  .line-1 {
    width: 60%;
  }

  .line-2 {
    width: 40%;
  }

  .skeleton-title {
    height: 24px;
    border-radius: 12px;
    margin-bottom: 12px;
    width: 80%;
    @include useTheme {
      background: getVar('bg-color1-f4f6f8');
    }
  }

  .skeleton-image {
    height: 150px;
    border-radius: 16px;
    margin-bottom: 12px;
    @include useTheme {
      background: getVar('bg-color1-f4f6f8');
    }
  }

  .skeleton-desc {
    height: 42px;
    border-radius: 8px;
    margin-bottom: 16px;
    width: 90%;
    @include useTheme {
      background: getVar('bg-color1-f4f6f8');
    }
  }

  .skeleton-actions {
    display: flex;
    justify-content: space-around;
  }

  .skeleton-btn {
    width: 80px;
    height: 32px;
    border-radius: 16px;
    @include useTheme {
      background: getVar('bg-color1-f4f6f8');
    }
  }

  @keyframes pulse {
    0%,
    100% {
      opacity: 1;
    }
    50% {
      opacity: 0.8;
    }
  }
  .noneData {
    position: fixed;
    top: 72px;
  }
}
.refreshBox {
  transform: translate3d(0px, 52px, 0);
}
.loadBox {
  padding: 6px 0 28px 0;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 72px;
  width: 100%;
  .spinner {
    border: 3px solid rgba(5, 216, 196, 0.2);
    border-radius: 50%;
    width: 18px;
    height: 18px;
    animation: spin 1s linear infinite;
    @include useTheme {
      border-top: 3px solid getVar('primary-color');
    }
  }
}
@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
